import { makeTotalData } from '@/lib/aggutil'
import { callApi } from './common'

function accountsSummary(params) {
  return callApi('billing-extend/consolidated', params).then((res) =>
    res.map((item) => makeTotalData(item))
  )
}

export default {
  accountsSummary,
}
